<template>
  <div class="member-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>会员昵称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入会员昵称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>手机号</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入手机号" v-model="table.search.phone"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>注册时间</p>
          </a-col>
          <a-col>
            <a-range-picker v-model="table.search.date" show-time class="app-block" valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>会员状态</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.status" class="app-block" placeholder="请选择会员状态">
              <a-select-option :value="1">启用</a-select-option>
              <a-select-option :value="0">禁用</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="state" slot-scope="text, data">
        <a-switch :checked="data.state === 1" :loading="data.stateLoading" @click="stateChange(data)"></a-switch>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="info(data)">详情</a-button>
          <a-button type="link" @click="pointsLog(data)">积分日志</a-button>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import MemberService from '@/io/member.js';

  export default {
    name: 'MemberManage',
    data() {
      let self = this;
      return {
        table: {
          loading: false,
          search: {
            name: null,
            phone: null,
            date: [],
            status: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '会员昵称',
              dataIndex: 'nickname'
            },
            {
              title: '姓名',
              dataIndex: 'name'
            },
            {
              title: '手机号',
              dataIndex: 'mobile'
            },
            {
              title: '积分',
              dataIndex: 'score'
            },
            {
              title: '注册时间',
              dataIndex: 'created_at'
            },
            {
              title: '会员状态',
              scopedSlots: { customRender: 'state' }
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        }
      }
    },
    mounted () {
      this.initData();
    },
    methods: {
      info(data) {
        this.$router.push(`/platform/member_manage/info/${data.id}`);
      },
      pointsLog(data) {
        this.$router.push(`/platform/member_manage/integral_log/${data.id}`);
      },
      stateChange(data) {
        let checked = data.state === 1;
        data.stateLoading = true;
        MemberService[checked ? 'disable' : 'enable'](data.id).then(res => {}).catch(err => {}).finally(() => {
          this.$afterFormSubmit(checked ? '关闭成功' : '开启成功');
          data.state = checked ? 0 : 1;
          data.stateLoading = false;
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          phone: null,
          date: [],
          status: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initData() {
        this.table.loading = true;
        return MemberService.listPage(
          this.table.search.name,
          this.table.search.phone,
          this.table.search.date[0],
          this.table.search.date[1],
          this.table.search.status,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            val.stateLoading = false;
            // val.region = `${val.province}${val.city}${val.area}`;
            // val.department = val.tissue.map(m => m.name).join(',');
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      },
    },
  }
</script>

<style lang="less" scoped>

</style>